import React from 'react';
import { Card, Row, Col, Button, Badge } from 'antd';
import {
  EyeOutlined,
  DeleteOutlined,
  CloudUploadOutlined,
  CloudOutlined,
  IdcardOutlined,
  PictureOutlined
} from '@ant-design/icons';

const FileListGrid = ({
  fileList,
  onPreview = () => null,
  onRemove = () => null,
  onTogglePublic = () => null,
  onSelect,
  onChangeImage,
  hasPublish = true,
  customActions,
  compact = true
}) => {
  const getActions = file => {
    if (customActions) return customActions(file);
    const actions = [
      <Button type="link" onClick={() => onPreview(file)} key="preview" icon={<EyeOutlined />}>
        {/* Preview */}
      </Button>,
      <Button
        type="link"
        danger
        onClick={() => onRemove(file)}
        key="remove"
        icon={<DeleteOutlined />}
      >
        {/* Remove */}
      </Button>
    ];
    if (onSelect)
      actions.unshift(
        <Button
          type="link"
          onClick={() => onSelect(file)}
          key="preview"
          icon={<PictureOutlined />}
        />
      );
    if (hasPublish)
      actions.unshift(
        <Button
          type="link"
          onClick={() => onTogglePublic(file)}
          key="togglePublic"
          icon={file.selected ? <CloudOutlined /> : <CloudUploadOutlined />}
        >
          {/* {file.selected ? 'Unpublish' : 'Publish'} */}
        </Button>
      );

    if (onChangeImage)
      actions.unshift(
        <Button
          type="link"
          onClick={() => onChangeImage(file)}
          key="togglePublic"
          icon={<IdcardOutlined />}
        >
          {/* Main */}
        </Button>
      );
    return actions;
  };

  return (
    <Row gutter={[16, 16]} justify="start">
      {fileList.map(file => (
        <Col key={file.uid} xs={24} sm={compact ? 12 : 24} md={compact ? 8 : 24}>
          <Badge.Ribbon
            text="Published"
            color="green"
            style={{
              display: file.selected ? 'block' : 'none'
            }}
          >
            <Badge.Ribbon
              text="Primary"
              color="blue"
              style={{
                top: '32px',
                display: file.isPrimary ? 'block' : 'none'
              }}
            >
              <Card
                hoverable
                cover={
                  <img
                    src={file.url || URL.createObjectURL(file.originFileObj)}
                    alt={file.name}
                    style={{ height: '350px', objectFit: 'cover' }}
                  />
                }
                actions={getActions(file)}
                bodyStyle={{ display: 'none' }}
              />
            </Badge.Ribbon>
          </Badge.Ribbon>
        </Col>
      ))}
    </Row>
  );
};

export default FileListGrid;
